import { render } from "./QuizChoixMetiers.vue?vue&type=template&id=0b0d1bdc&scoped=true"
import script from "./QuizChoixMetiers.vue?vue&type=script&lang=js"
export * from "./QuizChoixMetiers.vue?vue&type=script&lang=js"

import "./QuizChoixMetiers.vue?vue&type=style&index=0&id=0b0d1bdc&scoped=true&lang=css"

import exportComponent from "C:\\projets\\salon-metiers-2026\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b0d1bdc"]])

export default __exports__